export default function clearAllFacets(facets) {
    return facets.map(({ options, ...f }) => ({
        ...f,
        options: options?.map(({ selected, ...o }) => ({ ...o, selected: false })),
    }));
}
